import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ColumnDefinition, ColumnVisibility } from '../../../core/model/column-definition';
import { ExpandedListViewItemDefinition } from '../../../core/model/expanded-list-view-item';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { CompanyService } from '../../../rent/service/data/company.service';
import { ReportService } from '../../service/data/report.service';
import { LocalDate } from '../../../core/model/local-date';
import { DwellingService } from '../../../rent/service/data/dwelling.service';
import { Money } from '../../../core/model/money';
import { canSubmitReportForm } from '../../utility/report-form-validation';

@Component({
    selector: 'app-brf-inner-fund-per-rental-object',
    templateUrl: './brf-inner-fund-per-rental-object.component.html',
    styleUrls: ['./brf-inner-fund-per-rental-object.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BrfInnerFundPerRentalObjectComponent implements OnInit {
  constructor(
    private _cdf: ColumnDefinitionFactory,
    companyService: CompanyService,
    private _nativeWindow: NativeWindowService,
    private _dataService: ReportService,
    private _dwellingService: DwellingService,
    fb: FormBuilder,
    fcf: FormControlExFactory
  ) {
    this.companyService = companyService;
    const today = new Date();
    let startPeriod = LocalDate.fromDate(new Date(today.getFullYear(), 0, 1));
    let endPeriod = LocalDate.fromDate(new Date(today.getFullYear(), 12, 0));

    this.form = fb.group({
      company: fcf.create('COMMON.COMPANY', null),
      periodFrom: fcf.createMandatory('REPORT.INNER_FUND.PERIOD_FROM', startPeriod),
      periodTo: fcf.createMandatory('REPORT.INNER_FUND.PERIOD_TO', endPeriod),
    });

    this.columnDefinitions = [
      this._cdf.createMoney('REPORT.INNER_FUND.OPENING_BALANCE', 'openingBalance'),
      this._cdf.createMoney('REPORT.INNER_FUND.ALLOCATION', 'allocation'),
      this._cdf.createMoney('REPORT.INNER_FUND.WITHDRAWAL', 'withdrawal'),
      this._cdf.createMoney('REPORT.INNER_FUND.CLOSING_BALANCE', 'closingBalance'),
    ];
  }

  companyService: CompanyService;

  columnDefinitions: ColumnDefinition[] = [];
  
  dataContext: ExpandedListViewItemDefinition[] = [];
  form: FormGroup;
  today = new Date();
  private _subscription: Subscription;
  protected expandAllRows: boolean = false;

  ngOnInit() {}

  onPrintPages() {
    if (!canSubmitReportForm(this.form)) return;
    window.print();
  }

  exportExcel(): void {
    if (!canSubmitReportForm(this.form)) return;

    if (this._subscription) {
      this._subscription.unsubscribe();
    }
    this._subscription = this._dataService.getBrfInnerFundPerRentalObjectExcel(this.form.value).subscribe(file => {
      this._nativeWindow.save(file);
    });
  }

  ngOnDestroy(): void {
    if (this._subscription) this._subscription.unsubscribe();
  }

  toggleExpandAllRows() {
    this.expandAllRows = !this.expandAllRows;
  }

  onSubmit() {
    this.expandAllRows = false;
    if (!canSubmitReportForm(this.form)) return;

    this._dataService.getBrfInnerFundPerRentalObjectReport(this.form.value).subscribe(data => {
      this.dataContext = data
        ? data.map(overview => {
            const model = new ExpandedListViewItemDefinition();
            model.caption = `${overview.rentalId} - ${overview.address}`;
            model.columnDefinitions = [
              this._cdf.createDate('REPORT.INNER_FUND.TRANSACTION_DATE', 'transactionDate'),
              this._cdf.create('REPORT.INNER_FUND.DESCRIPTION', 'description'),
              this._cdf.createMoney('REPORT.INNER_FUND.AMOUNT', 'transactionAmount'),
            ];
            model.dataContext = overview;
            model.itemsSource = overview.brfInnerFundTransactionModels.map(x => {
              return {
                transactionDate: new LocalDate(x.transactionDate.year, x.transactionDate.month, x.transactionDate.day),
                transactionAmount: x.amount,
                description: x.description,
              };
            });

            return model;
          })
        : [];
    });
  }
}
